<template>
	<v-dialog
			v-model="componentState_.showInformationDialog"
			persistent
			width="600px">
		<v-card>
			<v-row no-gutters>
				<v-col>
					<v-card-title>
						<span v-text="$_infoDlg_stateComponentInformationDialogTitle" />
					</v-card-title>
					<v-card-text>
						<span v-text="$_infoDlg_stateComponentInformationDialogText" />
					</v-card-text>
				</v-col>
				<template v-if="$_infoDlg_stateComponentInformationDialogImgUrl">
					<v-col cols="2">
						<v-img	class="customVImg ma-4"
								:src="$_infoDlg_stateComponentInformationDialogImgUrl" />
					</v-col>
				</template>
			</v-row>
			<v-row dense>
				<v-col>
					<v-card-actions>
						<v-row dense justify="center">
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										color="primary"
										@click="$_infoDlg_ok()"
										v-text="$_infoDlg_stateComponentInformationDialogOkButtonTitle" />
							</v-col>
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										@click="$_infoDlg_close()">
									Close
								</v-btn>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'InformationDialog',
		data() {
			return {
				empty_: {
					title: null,
					text: null,
					img: {
						url: null
					},
					okButton: {
					//	to: '/'
					}
				}
			}
		},
		computed: {
			$_infoDlg_stateComponentInformationDialogTitle() {
				const self_ = this;
				const dialog_ = self_.getComponentState('informationDialog')
				if(self_.isEmpty(dialog_)) { return null }
				return dialog_.title
			},
			$_infoDlg_stateComponentInformationDialogText() {
				const self_ = this;
				const dialog_ = self_.getComponentState('informationDialog')
				if(self_.isEmpty(dialog_)) { return null }
				return dialog_.text
			},
			$_infoDlg_stateComponentInformationDialogImg() {
				const self_ = this;
				const dialog_ = self_.getComponentState('informationDialog')
				if(self_.isEmpty(dialog_)) { return null }
				return dialog_.img
			},
			$_infoDlg_stateComponentInformationDialogImgUrl() {
				const self_ = this;
				const img_ = self_.$_infoDlg_stateComponentInformationDialogImg;
				if(self_.isEmpty(img_)) { return null }
				return img_.url
			},
			$_infoDlg_stateComponentInformationDialogOkButton() {
				const self_ = this;
				const dialog_ = self_.getComponentState('informationDialog')
				if(self_.isEmpty(dialog_)) { return null }
				return dialog_.okButton
			},
			$_infoDlg_stateComponentInformationDialogOkButtonTitle() {
				const self_ = this;
				const button_ = self_.$_infoDlg_stateComponentInformationDialogOkButton;
				if(self_.isEmpty(button_)) { return null }
				return button_.title
			},
			$_infoDlg_stateComponentInformationDialogOkButtonLink() {
				const self_ = this;
				const button_ = self_.$_infoDlg_stateComponentInformationDialogOkButton;
				if(self_.isEmpty(button_)) { return null }
				return button_.link
			}
		},
		created() {
			const self_ = this;

			self_.componentState_ = self_.getState('component')
		},
		methods: {
			$_infoDlg_ok() {
				const self_ = this;

				self_.openLink(self_.$_infoDlg_stateComponentInformationDialogOkButtonLink)

				self_.$_infoDlg_close()
			},
			$_infoDlg_close() {
				const self_ = this;

				self_.setComponentState('informationDialog', self_.empty_)

				self_.setComponentState('showInformationDialog', false)
			}
		}
	}
</script>

<style scoped>
</style>